import { createAsyncThunk } from '@reduxjs/toolkit';

import { IUser } from '../UserSlice';
import { ApiPaths, APIDataProvider, TApiResponse } from '../../api';
import { ICheckoutSession, IProductPrice, ISubscriptionSession } from '.';

interface ICreateSession {
  diagnosticId: string;
}

interface ICreatePremiumSession {
  userId: string;
  priceId: string;
  returnUrl: string;
}

interface IPremiumSessionWithDetails {
  userId: string;
  priceId: string;
  returnUrl: string;
  email: string;
  fullName: string;
  phoneNumber: string;
  country: string;
}

interface IGetPremiumPrice {
  userId?: string;
  country: string;
}

interface IPremiumSession {
  user: IUser;
  session: ICheckoutSession;
}

const apiDataProvider = new APIDataProvider();

export const createSession = createAsyncThunk(
  'stripe/createSession',
  async (data: ICreateSession) => {
    const response = await apiDataProvider.post<TApiResponse<ICheckoutSession>>(
      `${ApiPaths.stripe}/createSession`,
      data
    );

    return response.data;
  }
);

export const getProductPrice = createAsyncThunk(
  'stripe/getProductPrice',
  async (diagnosticId: string) => {
    const response = await apiDataProvider.get<TApiResponse<IProductPrice>>(
      `${ApiPaths.stripe}/getProductPrice/${diagnosticId}`
    );

    return response.data;
  }
);

export const createPremiumSession = createAsyncThunk(
  'stripe/premium/createSession',
  async (data: ICreatePremiumSession) => {
    const response = await apiDataProvider.post<TApiResponse<ICheckoutSession>>(
      `${ApiPaths.stripe}/premium/createSession`,
      data
    );

    return response.data;
  }
);

export const getPremiumProductPrice = createAsyncThunk(
  'stripe/premium/getProductPrice',
  async (data: IGetPremiumPrice) => {
    const response = await apiDataProvider.post<TApiResponse<IProductPrice[]>>(
      `${ApiPaths.stripe}/premium/getProductPrice`,
      data
    );

    return response.data;
  }
);

export const getSubscriptionSessionById = createAsyncThunk(
  'stripe/premium/getById',
  async (id: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<ISubscriptionSession>
    >(`${ApiPaths.stripe}/premium/${id}`);

    return response.data;
  }
);

export const getCustomerPortal = createAsyncThunk(
  'stripe/customerPortal',
  async (userId: string) => {
    const response = await apiDataProvider.get<TApiResponse<ICheckoutSession>>(
      `${ApiPaths.stripe}/customerPortal/${userId}`
    );

    return response.data;
  }
);

export const createPremiumSessionWithDetails = createAsyncThunk(
  'stripe/premium/createSessionWithDetails',
  async (data: IPremiumSessionWithDetails) => {
    const response = await apiDataProvider.post<TApiResponse<IPremiumSession>>(
      `${ApiPaths.stripe}/premium/createSessionWithDetails`,
      data
    );

    return response.data;
  }
);
